<template>
<div class="nav">
  <btn-icon @click.native="closeNav" class="nav__close" btn-type="secondary" btn-inverse btn-size="s">
    <font-awesome-icon :icon="times"/>
  </btn-icon>
  <div class="nav__content">
    <div class="nav__item nav__logo">
      <logo-menu />
    </div>
    <ul class="nav__menu">
      <template
        v-for="(entry, index) in getMainMenuEntries()">
        <li
          v-if="hasChildren(entry) && !isFeatured(entry.routeName)"
          v-has-any-feature="getChildrenFeatures(entry.children)"
          v-bind:key="index">
          <span v-has-any-route="getChildrenRoutes(entry)">
            <button @click="toggleSubnav(entry, $event)" class="nav__menu-item has-subnav">
              {{ $t(entry.label) }}
              <arrow-down class="subnav__icon" />
            </button>
            <slide-up-down :active="getMenuStatus(entry)">
              <ul class="subnav">
                <template
                  v-for="(subEntry, subIndex) in entry.children">
                  <li
                    v-if="isFeatured(subEntry.routeName)"
                    v-has-feature="getFeatureName(subEntry.routeName)"
                    v-has-route="getPathFromEntry(subEntry)"
                    v-bind:key="subIndex">
                    <router-link
                      :to="getPathFromEntry(subEntry)"
                      class="nav__menu-item">
                      {{ $t(subEntry.label) }}
                    </router-link>
                  </li>
                </template>
              </ul>
            </slide-up-down>
          </span>
        </li>
        <li
          v-if="hasChildren(entry) && isFeatured(entry.routeName)"
          v-has-feature="getFeatureName(entry.routeName)"
          v-bind:key="index">
          <span v-has-any-route="getChildrenRoutes(entry)">
            <button @click="toggleSubnav(entry, $event)" class="nav__menu-item has-subnav">
              {{ $t(entry.label) }}
              <arrow-down class="subnav__icon" />
            </button>
            <slide-up-down :active="getMenuStatus(entry)">
              <ul class="subnav">
                <li
                  v-for="(subEntry, subIndex) in entry.children"
                  v-has-route="getPathFromEntry(subEntry)"
                  v-bind:key="subIndex">
                  <router-link
                    :to="getPathFromEntry(subEntry)"
                    class="nav__menu-item">
                    {{ $t(subEntry.label) }}
                  </router-link>
                </li>
              </ul>
            </slide-up-down>
          </span>
        </li>
        <safe-router-link
          v-if="!hasChildren(entry) && getPathFromEntry(entry) !== null && isFeatured(entry.routeName)"
          v-has-feature="getFeatureName(entry.routeName)"
          :to="getPathFromEntry(entry)"
          v-bind:key="index"
          class="nav__menu-item">
          <li>
            {{ $t(entry.label) }}
          </li>
        </safe-router-link>
        <safe-router-link
          v-if="!hasChildren(entry) && getPathFromEntry(entry) !== null && !isFeatured(entry.routeName)"
          :to="getPathFromEntry(entry)"
          v-bind:key="index"
          class="nav__menu-item">
          <li>
            {{ $t(entry.label) }}
          </li>
        </safe-router-link>
      </template>
    </ul>
    <user-nav />
    <div class="nav__item nav__logo50">
      <dwall />
    </div>
  </div>
</div>
</template>

<script>
import BtnIcon from '@/components/shared/buttons/BtnIcon';
import LogoMenu from '@/components/shared/logos/LogoMenu';
import Dwall from '@/components/shared/logos/Dwall';
import UserNav from '@/components/shared/UserNav';
import ArrowDown from '@/components/shared/icons/IconArrowDown';
import SafeRouterLink from '@/components/shared/SafeRouterLink';
import SlideUpDown from 'vue-slide-up-down';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';
import {eventBus} from '@/main';
import config from 'BRAND/config';
import { mapGetters } from 'vuex';

export default {
  components: {
    BtnIcon,
    LogoMenu,
    Dwall,
    UserNav,
    ArrowDown,
    SlideUpDown,
    FontAwesomeIcon,
    SafeRouterLink
  },
  data () {
    return {
      menuActiveDemo: false,
      menuActive1: false,
      menuActive2: false,
      menuActive: []
    };
  },
  created () {
    this.getMainMenuEntries().forEach(menuEntry => {
      if (this.hasChildren(menuEntry)) {
        this.menuActive.push({
          routeName: menuEntry.routeName,
          active: false
        });
      }
    });
  },
  computed: {
    ...mapGetters(['getUserAccount']),
    times () {
      return faTimes;
    }
  },
  methods: {
    closeNav () {
      eventBus.$emit('navClosed');
    },
    toggleSubnav (menuElement, event) {
      let toggleTarget = event.target;
      if (!toggleTarget.classList.contains('nav__menu-item')) {
        toggleTarget = toggleTarget.closest('.nav__menu-item');
      }
      toggleTarget.classList.toggle('is-subnav-open');
      const expandableMenu = this.menuActive.find(menuEntry => menuEntry.routeName === menuElement.routeName);
      expandableMenu.active = !expandableMenu.active;
    },
    getMainMenuEntries () {
      return config.mainMenuEntries !== undefined ? config.mainMenuEntries : [];
    },
    getPathFromEntry (entry) {
      if (entry.routeByRole) {
        const account = this.getUserAccount
        const authorities = (account && account.authorities) ? account.authorities : []
        for (const [role, routeName] of Object.entries(entry.routeByRole)) {
          if (authorities.includes(role)) {
            const route = config.routes.find(r => r.name === routeName)
            return route !== undefined ? route.path : null
          }
        }
      }

      const route = config.routes.find(route => route.name === entry.routeName)
      return route !== undefined ? route.path : null
    },
    isFeatured (name) {
      const featuredRoute = config.routes.find(route => route.name === name);
      if (featuredRoute !== undefined && featuredRoute !== null && featuredRoute.meta !== undefined && featuredRoute.meta !== null) {
        return config.featurePermission.some(featurePermission => featurePermission.feature === featuredRoute.meta.feature);
      }
      return null;
    },
    getFeatureName (routeName) {
      const featuredRoute = config.routes.find(route => route.name === routeName);
      if (featuredRoute !== undefined && featuredRoute !== null && featuredRoute.meta !== undefined && featuredRoute.meta !== null) {
        return featuredRoute.meta.feature;
      }
      return null;
    },
    hasChildren (entry) {
      return entry.children !== undefined;
    },
    getChildrenRoutes (entry) {
      const routes = [];
      entry.children.forEach(subEntry => {
        routes.push(this.getPathFromEntry(subEntry));
      });
      return routes;
    },
    getMenuStatus (entry) {
      return this.menuActive.find(menu => menu.routeName === entry.routeName).active;
    },
    getChildrenFeatures (entry) {
      const featureArray = [];
      entry.forEach(child => {
        featureArray.push(this.getFeatureName(child.routeName));
      });
      return featureArray;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../stylesheets/variables.scss";

$padding-nav: $sp * 8;

.nav {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: $nav_background;
  color: $bodycolor-inverse;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    @if($nav-image == true) {
      background-image: url($brandImage-MainNavBefore);
    }
    background-size: cover;
    z-index: 0;
    opacity: 0.1;
    pointer-events: none;
  }

  &__close {
    position: absolute;
    top: $padding-nav / 2;
    right: $padding-nav / 2;
  }
  &__content {
    padding-top: $padding-nav;
    padding-bottom: $padding-nav;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: auto;
  }
  &__item {
    padding-left: $padding-nav;
    padding-right: $padding-nav;
  }
  &__menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  &__menu-item {
    padding: $sp * 2 $padding-nav;
    display: block;
    color: $bodycolor-inverse;
    background-color: transparent;
    width: 100%;
    border: 0;
    text-transform: uppercase;
    font-weight: 700;
    transition: 0.3s;
    &:hover,
    &:active {
      box-shadow: inset ($sp * 2) 0 0 $secondary-light2;
      color: $white-trans4;
    }
    &:focus {
      outline: 0;
    }
    &.is-active {
      background: $secondary-dark1;
      box-shadow: inset ($sp * 2) 0 0 $secondary-light6;
      &:hover {
        color: inherit;
      }
    }
  }
  &__logo {
    margin-bottom: $sp * 6;
    width: $nav_logo_width;
  }
  &__logo50 {
    margin-top: auto;
    padding-top: $sp * 4;
    width: 200px;
    margin-bottom: $sp * 4;
  }
}

.subnav {
  list-style: none;
  padding: 0;
  margin: 0;
  .nav__menu-item {
    text-transform: inherit;
    padding-left: $padding-nav + $sp * 3;
    svg {
      opacity: 0.25;
      margin-right: $sp;
      transition: 0.3s;
    }
    &:hover svg {
      opacity: 1;
      //color: $white;
      color: $white-trans4;
    }
  }
}

.has-subnav {
  display: flex;
  .subnav__icon {
    margin-left: auto;
  }
  &:hover {
    .subnav__icon {
      color: $white-trans4;
    }
  }
  &.is-subnav-open {
    .subnav__icon {
      transform: rotate(180deg);
    }
  }
  .has-active-link & {
    box-shadow: inset ($sp * 2) 0 0 $secondary-light2;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/shared/MainNav.vue